import Animations from './animations';
import MediaLazyLoad from './modules/MediaLazyLoad';
// Header
class Header {

    constructor() {
        this.init();
    }

    init() {
        this.header = document.querySelector<HTMLElement>('.header');
        this.body = document.body;
        this.document = document.documentElement;
        //this.attachListeners();
    }

     attachListeners() {
        window.addEventListener('scroll', () => {
            if (this.body.scrollTop >= 50 || this.document.scrollTop >= 50) {
                this.header.classList.add('scrolled');
            } else if (this.body.scrollTop === 0 || this.document.scrollTop === 0) {
                this.header.classList.remove('scrolled');
            }
        });
    }
}

// Language switcher
class LanguageSwitcher {

    constructor() {
        this.languageMenuContainer = document.querySelector('[data-language-menu]');
        // Verify that the language menu container exists
        if (document.contains(this.languageMenuContainer)) {
            this.languageMenuToggle = this.languageMenuContainer.querySelector('.language-switch-link');
            this.attachListeners();
        }
    }

    attachListeners() {
        this.languageMenuToggle.addEventListener('click', () => this.toggleLanguageMenu());
    }

    toggleLanguageMenu() {
        if (this.languageMenuContainer.classList.contains('active')) {
            this.languageMenuContainer.classList.remove('active');
        } else {
            this.languageMenuContainer.classList.add('active');
        }
    }
}

// Mobile Navigation
class MobileNavigation {

    constructor() {
        this.body = document.body;
        this.mobileMenuToggle = document.querySelector('[data-mobile-menu-toggle]');
        this.mobileMenu = document.querySelector('[data-mobile-menu]');
        this.submenuItems = document.querySelectorAll('.mob-submenu-toggle');
        this.pageOverlay = document.querySelector('[data-page-overlay]');
        this.siteHeader = document.querySelector('.header');

        if(!this.mobileMenuToggle || !this.mobileMenu) return;

        this.addEventListeners();
    }

    addEventListeners() {
        this.mobileMenuToggle.addEventListener('click', () => this.toggleNavigation());

        this.submenuItems.forEach((toggle) => {
            if (toggle.parentElement.classList.contains('menu-item-has-children')) {
                toggle.addEventListener('click', () => {
                    if (toggle.parentElement.classList.contains('active')) {
                        toggle.parentElement.classList.remove('active');
                    } else {
                        toggle.parentElement.classList.add('active');
                    }
                });
            }
        });
        //this.submenuItem.addEventListener('click', () => this.toggleSubmenu());
    }

    toggleNavigation() {
        if (this.mobileMenuToggle.classList.contains('active')) {
            this.body.classList.remove('no-scroll');
            this.pageOverlay.classList.remove('visible');
            this.mobileMenuToggle.classList.remove('active');
            this.mobileMenu.classList.remove('open');
            this.siteHeader.classList.remove('menu-open');
        } else {
            this.body.classList.add('no-scroll');
            this.pageOverlay.classList.add('visible');
            this.mobileMenuToggle.classList.add('active');
            this.mobileMenu.classList.add('open');
            this.siteHeader.classList.add('menu-open');
        }
    }

    toggleSubmenu() {
        if(this.submenuItem.parentElement.classList.contains('active')) {
            this.submenuItem.parentElement.classList.remove('active');
            this.submenuItem.classList.remove('active');
        } else {
            this.submenuItem.parentElement.classList.add('active');
            this.submenuItem.classList.add('active');
        }
    }
}

class OpenSideMenu {
    constructor() {
        this.platformMenu   = document.querySelector('.platform-menu');
        this.bottomNav      = document.querySelector('.header-sidemenu-modal');
        this.platformToggle = document.querySelector('.platform-menu-toggle');
        this.searchToggle   = document.querySelector('.button-search-toggle');
        this.searchForm     = document.querySelector('.header-search-form');
        this.siteToggle     = document.querySelector('.button-site-toggle');
        this.siteMenu       = document.querySelector('.header-country-menu');
        this.iconItems      = document.querySelectorAll('.header-icon-menu-item');

        if(this.bottomNav) {
            this.activeSide = this.bottomNav.querySelectorAll('.side-menu-item');
        }

        this.addEventListeners();
    }

    addEventListeners() {
        if(this.platformToggle) {
            this.platformToggle.addEventListener('click', () => {
                this.toggleMenu();
            });
        }

        if(this.searchToggle) {
            this.searchToggle.addEventListener('click', () => {
                this.toggleSearchForm();
            });
        }

        if(this.siteToggle) {
            this.siteToggle.addEventListener('click', () => {
                this.toggleSiteMenu();
            });
        }
    }

    toggleBottomNavOn($activeMenu, $activeButton) {
        this.bottomNav.classList.add('active');
        if (this.bottomNav.classList.contains('active')) {
            this.closePreviouslyOpened();
        }

        $activeMenu.classList.add('active');
        $activeButton.classList.add('active');
    }

    toggleBottomNavOff() {
        this.bottomNav.classList.remove('active');
        this.closePreviouslyOpened();
    }

    closePreviouslyOpened() {
        this.activeSide.forEach((item) => {
            if(item.classList.contains('active')){
                item.classList.remove('active');
            }
        });
        this.iconItems.forEach((item) => {
            if(item.classList.contains('active')){
                item.classList.remove('active');
            }
        });
    }

    toggleMenu() {
        if (this.platformToggle.classList.contains('active')) {
            this.platformMenu.classList.remove('active');
            this.toggleBottomNavOff();
        } else {
            this.toggleBottomNavOn(this.platformMenu, this.platformToggle);
        }
    }

    toggleSearchForm() {
        if (this.searchToggle.classList.contains('active')) {
            this.searchForm.classList.remove('active');
            this.toggleBottomNavOff();
        } else {
            this.toggleBottomNavOn(this.searchForm, this.searchToggle);
        }
    }

    toggleSiteMenu() {
        if (this.siteToggle.classList.contains('active')) {
            this.siteMenu.classList.remove('active');
            this.toggleBottomNavOff();
        } else {
            this.toggleBottomNavOn(this.siteMenu, this.siteToggle);
        }
    }
}

class MainNavigation {

    constructor() {
        this.header = document.querySelector('[data-header]');
        this.mainNavigation = document.querySelector('.header-navigation');
        this.bottomNav = document.querySelector('.header-submenu-modal');
        this.sideNav = document.querySelector('.header-sidemenu-modal');
        this.iconItems = document.querySelectorAll('.header-icon-menu-item');
        this.secondaryMenuContainers = document.querySelectorAll('.submenu-nav');

        if(!this.mainNavigation || !this.bottomNav || !this.sideNav) return;

        this.menuItems = this.mainNavigation.querySelectorAll('.menu-item');
        this.activeSide = this.sideNav.querySelectorAll('.side-menu-item');

        this.addEventListeners();

        let zIndex = getComputedStyle(document.body).zIndex;
        if (zIndex == "3") {
            this.addEventListeners();
        }

        window.addEventListener('resize', () => {
            if (zIndex == "3") {
                this.addEventListeners();
            }
        });
    }

    addEventListeners() {
        this.menuItems.forEach((toggle) => {
            if (toggle.classList.contains('menu-item-has-children')) {
                toggle.addEventListener('mouseenter', () =>  {
                    this.openDropdown(toggle);
                    this.closeSideMenu();
                });
            } else {
                toggle.addEventListener('mouseenter', () => this.closeDropdown());
            }
        });
        this.secondaryMenuContainers.forEach((menuContainer) => {
            menuContainer.addEventListener('mouseleave', () => this.closeDropdown())
        });
    }

    closeSideMenu() {
        if (this.sideNav.classList.contains('active')) {
            this.sideNav.classList.remove('active');
            this.activeSide.forEach((item) => {
                if(item.classList.contains('active')){
                    item.classList.remove('active');
                }
            });
            this.iconItems.forEach((item) => {
                if(item.classList.contains('active')){
                    item.classList.remove('active');
                }
            });
        }
    }

    openDropdown(toggle) {
        this.menuItems.forEach((toggle) => toggle.classList.remove('active'));
        toggle.classList.add('active');
        var parentElement = toggle.getAttribute('id');

        this.secondaryMenuContainers.forEach((menuContainer) => {
            menuContainer.classList.remove('active');
            if (menuContainer.getAttribute('data-menu-parent') == parentElement) {
                menuContainer.classList.add('active');
            }
        });
        this.bottomNav.classList.add('active');
    }

    closeDropdown() {
        this.secondaryMenuContainers.forEach((menuContainer) => menuContainer.classList.remove('active'));
        this.menuItems.forEach((toggle) => toggle.classList.remove('active'));
        this.bottomNav.classList.remove('active');
    }
}

new Header();
new LanguageSwitcher();
new MobileNavigation();
new MainNavigation();
new OpenSideMenu();
new Animations();
new MediaLazyLoad();